import React, {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {View, Text, StyleSheet, TouchableOpacity, FlatList} from 'react-native';
import {useSelector} from 'react-redux';
import {globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {globalFormStyle} from '../../../assets/GlobalStyle/globalFormStyle';
import {usePolling} from '../../../common/usePolling';
import CustomButton from '../../../commonComponents/CustomButton';
import CustomInput from '../../../commonComponents/CustomInput';
import {Network} from '../../../utils/network';
import InsufficientFundBlk from './InsufficientFundsBlk';
import {trackMoengageEvent} from '../../../utils/commonMethods';

const ClubOptionsForm = ({
  orderStatus,
  clubEventDetails,
  onDifferentOptions,
  optionSelectedIndex,
  onBottomSheetClose,
}) => {
  const {
    control,
    formState: {errors, isValid, isSubmitting},
    handleSubmit,
    reset,
    watch,
    setValue,
  } = useForm({mode: 'onChange'});
  const optionSelected =
    clubEventDetails && clubEventDetails?.options[optionSelectedIndex];
  let userInfo = useSelector(({profile}) => profile?.profileData);
  const walletBalance = parseFloat(userInfo?.coinsd)?.toFixed(2);

  const watchAmount = watch('currentAmount', 0);

  useEffect(() => {
    reset({
      currentAmount: clubEventDetails?.default_amount,
    });
  }, []);

  usePolling(
    () => {
      getUpdatedOdds(watchAmount);
    },
    5000,
    true,
  );

  useEffect(() => {
    getUpdatedOdds(watchAmount);
  }, [watchAmount]);

  const getUpdatedOdds = async amount => {
    if (amount > 0) {
      const res = await Network.getUpdatedClubOdds(
        {eventId: clubEventDetails?.id, clubId: clubEventDetails?.club_id},
        {
          amount: +amount,
        },
      );
      if (res?.data) {
        onDifferentOptions(res?.data);
      }
      //console.log(data);
    }
  };

  const onPlaceOrder = async () => {
    if (!isSubmitting) {
      const req = {
        coins: +watchAmount,
        option_id: optionSelected?.id,
        options: clubEventDetails?.options,
      };
      trackMoengageEvent('Club Market order place', {
        coins: +watchAmount,
        option_id: optionSelected?.id,
        options: clubEventDetails?.options,
      });
      const res = await Network.placeClubBet(
        {eventId: clubEventDetails?.id, clubId: clubEventDetails?.club_id},
        req,
        true,
      );

      //const res = { data: "success" };
      orderStatus({orderResponse: res?.data});
    }
  };
  return (
    <View style={{marginBottom: 20}}>
      <Text style={[styles.formTitle, {marginBottom: 12}]}>Amount</Text>
      <CustomInput
        name="currentAmount"
        placeholder=""
        type={'number'}
        control={control}
        isNumberKeyboard={true}
        isTextAlignLeft={true}
        rules={{
          required: true,
          min: {
            value: 1,
          },
          max: {
            value: clubEventDetails?.max_amount,
          },
        }}
      />
      {errors?.currentAmount?.type === 'max' && (
        <Text style={globalStyle.errorText}>
          Cannot purchase shares worth more than
          {clubEventDetails?.max_amount || 1000} at a time
        </Text>
      )}
      <Text style={{marginBottom: 25, marginTop: 10}}>
        Available Balance: {walletBalance}
      </Text>
      <View style={globalFormStyle.tableContainerRowNewForm}>
        <Text style={globalFormStyle.fieldLeft}>ROI</Text>

        <Text style={globalFormStyle.fieldRight}>
          {(optionSelected?.roi * 100)?.toFixed(2)}&nbsp;%
        </Text>
      </View>
      <View style={globalFormStyle.tableContainerRowNewForm}>
        <Text style={globalFormStyle.fieldLeft}>Potential Returns</Text>

        <Text style={globalFormStyle.fieldRight}>
          {(watchAmount * optionSelected?.roi)?.toFixed(2)}
        </Text>
      </View>
      <View style={{marginTop: 20}}>
        <CustomButton
          btnText="Place Order"
          btnType={isValid ? 'normalBlue' : 'disable'}
          onBtnClick={handleSubmit(onPlaceOrder)}
        />
      </View>
      {watchAmount !== null && walletBalance < +watchAmount && (
        <InsufficientFundBlk
          amount={watchAmount}
          balance={walletBalance}
          onBottomSheetClose={onBottomSheetClose}
        />
      )}
    </View>
  );
};

export default ClubOptionsForm;

const styles = StyleSheet.create({
  formTitle: {
    ...globalFontStyle.appFontSubHeading,
    color: Colors.black,
  },
});
